export const COLORS = Object.freeze({
	BLUE: 'rgba(43, 151, 240, 1)',
	RED: 'rgba(220, 20, 60, 1)',
	YELLOW: 'rgba(235, 186, 26, 1)'
});

export const SERIES_POSITION = Object.freeze({
	LEFT: 'left',
	RIGHT: 'right'
});